import {ProjectJobAttachmentService} from '../project-job-attachment.service';
import {Observable, of} from 'rxjs';
import {ProjectJobAttachment} from '../../models/project-job-attachment';

export class ProjectJobAttachmentServiceMock implements ProjectJobAttachmentService {
    getAttachments(projectId: number, formId: number): Observable<ProjectJobAttachment[]> {
        return of([]);
    }
}
